import apiUrl from '../../../constants'
import axios from 'axios'
import {
	Validator
} from 'vee-validate'
import vSelect from 'vue-select'
import moment from 'moment'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js';
import Loader from './../shared/loader'
import Pagination from './../shared/pagination'
import {
	data
} from 'jquery'

export default {
	name: 'multipicker',
	components: {
		Pagination,
		vSelect,
		DatePicker,
		Loader,
	},
	props: ['selectedRow', 'filterData'],
	data: function() {
		return {

			orderid: this.selectedRow.orderid || this.selectedRow.poid,
			urlclientid: this.filterData.clientid,
			urlwarehouseid: this.filterData.warehouseid,
			inwardErrors: {},
			result: [],
			inwardaction: '',
			addinwardmodal: false,
			listPOData: [],
			listInwardData: [],
			listSupplierData: [],
			counter: 0,
			isLoading: false,
			//to close the modal(dependent form field)
			poerrors: '',
			Dateerrors: '',
			isDateError: '',
			isError: '',
			referenceNo: '',
			createdbyEmail: '',
			Qtyerrors: '',
			POmapflag: false,
			invoicedate: null,
			modalMessageShowpo: false,
			validate_po_mandate: false,
			emptyPO: '',


			listMerchantData: [],
			listClientData: [],
			listWarehouseData: [],
			merchant: '',
			merchantid: '',
			client: '',
			clientid: '',
			warehouse: '',
			warehouseid: '',
			showSelectClient: false,
			showSelectWarehouse: false,
			clientList: [],
			warehouseList: [],
			merchantList: [],
			ClientErr: '',
			WarehouseErr: '',
			grcstarted: '',
			pickerAssignmentShow: false,
			pickerListData: '',
			pickerid: '',
			SelectPickerErr: '',
			listOrdersData: [],
			selectAll: false,
			checkallflag: true,
			selectedRowData: [],
			selectrack: '',
			selectqty: 0,
			totalrack: '',
			//   selectedFilterData: [],
			orderids: '',
			totalPage: 0,
			totalRows: 0,
			currentPage: 1,
			loginuserid: '',
			pageLimit: 5,
			selectedrack: [],
			selectedrackid: [],
			rackid: "",
			selectedrackid1: "",
			totalqty: 0,
			selectedcheckbox: [],
			alltotalqty: 0,
			notselqty: 0,

		}
	},
	computed: {},
	filters: {
		moment: function(date) {
			return moment(date).format('DD-MM-YYYY');
		}
	},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.getbtobdata();
		this.getPickersList();
		this.getOrderSerach();
		this.loginuserid = userdetail.userid;
		this.pageNo = 0;
		this.totalRows = 0;
		this.listOrdersData = [];
		this.listMerchantData = [];
		this.pageNo = this.totalPage = 0;
		this.selectedrack = [];
		this.user_type = userdetail.utype;
		switch (this.user_type) {
			case 'system_user':
			case 'warehouse_user':
				this.createdbyEmail = userdetail.email;
				break;

			case 'client_user':
			default:
				this.$alertify.error("Unauthorised user, Please contact your system admin");
				break
		}


		if (this.selectedRow) {
			this.selectedRowData.push(this.selectedRow)
		}
	},
	methods: {
		dateFormatFRT(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		},
		showList() {
			this.$emit("goBackToParent")
		},
		selectAllCheckbox: function() {

			if (this.checkallflag == true) {

				this.SelectedRows = [];
				if (this.selectAll) {
					for (let order in this.listOrdersData) {
						if (this.selectedrack.indexOf(this.listOrdersData[order].rackid) == -1)
							this.selectedrack.push(this.listOrdersData[order].rackid);
					}
					this.selectedAllCheckbox(this.listOrdersData)

				} else {

					for (let order in this.listOrdersData) {
						if (this.selectedrack.indexOf(this.listOrdersData[order].rackid) >= 0) {
							this.selectedrack.splice(this.selectedrack.indexOf(this.listOrdersData[order].rackid), 1);

						}

					}
					this.selectedAllUnCheckbox(this.listOrdersData)

				}
			} else {}
			this.updateSelectedCheckBox();
		},
		selectCheckbox: function(value, event) {
			let qty = 0;
			if (event.target.checked) {
				this.selectrack = this.selectedrack.length;
				for (let i = 0; i < this.listOrdersData.length; i++) {
					if (this.selectedrack.indexOf(this.listOrdersData[i].rackid) >= 0) {
						for (let j = 0; j < this.listOrdersData[i].iteminfo.length; j++) {
							qty += Number(this.listOrdersData[i].iteminfo[j][3]);

						}
					}
				}
			} else {
				let unqty = this.selectqty;
				this.selectrack = this.selectedrack.length;
				for (let order in this.listOrdersData) {
					let uncheckedqty = 0
					if (this.listOrdersData[order].rackid == value) {
						for (let i = 0; i < this.listOrdersData[order].iteminfo.length; i++)
							uncheckedqty += Number(this.listOrdersData[order].iteminfo[i][3]);
					}
				}

			}
			this.updateSelectedCheckBox();
			this.selectAllManually();
		},
		selectAllManually: function() {

			for (let x = 0; x < this.selectedcheckbox.length; x++) {
				if (Number(this.currentPage) == Number(this.selectedcheckbox[x].page)) {
					if (((Number(this.listOrdersData.length) ==  Number(this.selectedcheckbox[x].count)) && (this.listOrdersData.length) !=0)) {
						this.selectAll = true
					} else {
						this.selectAll = false
					}
				}
			}
		},
		selectedAllCheckbox: function() {
			if (this.selectAll) {
				this.selectrack = this.selectedrack.length;

			}
			this.updateSelectedCheckBox();
			this.selectAllManually();

		},
		selectedAllUnCheckbox: function() {
			this.selectrack = this.selectedrack.length;

			this.updateSelectedCheckBox();
			this.selectAllManually();

		},
		resetAll: function(myAction, event) {
			if (myAction == 1) {
				this.selectedrack = [];
				this.selectAll = false;
			} else {}


		},
		getPickersList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				warehouseid: this.urlwarehouseid,
			});
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getWarehousePickerList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.pickerListData = result.data.data.data;
				}, error => {
					console.error(error)
				})
		},


		//assign order to multipicker
		assignOrderToMultiPicker() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			this.pickerAssignmentShow = false;

			this.isLoading = true;
			this.input = {
				clientid: this.urlclientid,
				warehouseid: this.urlwarehouseid,
				selectedorder: this.orderid,
				userid: this.loginuserid,
				pickerid: this.pickerid,
				selectedrack: this.selectedrack
			}

			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'assignOrderToMultiPicker',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					if (result.data.data.ErrorCode == 0) {
						this.totalPage = this.totalPage - this.selectedrack.length
						this.$alert(result.data.data.msg, '', "success");
						this.getOrderSerach();
						this.$emit("goBackToParent")

					} else {
						this.$alert(result.data.data.msg, '', "error");
					}
					this.isLoading = false;
					this.selectAll = false;
					this.pickerid = '';
					this.selectedrack = [];

				}, error => {
					console.error(error);
				});
		},
		//get data

		onPageChange(page) {
			this.currentPage = page;
		  this.selectAll = false;
			this.getbtobdata();
		},
		updateSelectedCheckBox() {
			let PageQty = 0;
			let Count = 0;
			for (let k = 0; k < this.listOrdersData.length; k++) {
       let i = 0;
			 if (this.selectedrack.indexOf(this.listOrdersData[k].rackid) >= 0) {
				for (let l = 0; l < this.listOrdersData[k].iteminfo.length; l++) {
						PageQty += Number(this.listOrdersData[k].iteminfo[l][3]);
					}
					Count = Count +1;
				}
			}
			let exist = 0
			for (let x = 0; x < this.selectedcheckbox.length; x++) {
				if (Number(this.currentPage) == Number(this.selectedcheckbox[x].page)) {
					exist = 1
					this.selectedcheckbox[x].checkedqty = PageQty;
					this.selectedcheckbox[x].rack = this.selectrack
					this.selectedcheckbox[x].count = Count
				}
			}

			if (exist == 0) {
				this.selectedcheckbox.push({
					page: this.currentPage,
					checkedqty: PageQty,
					rack: this.selectrack,
					count:Count
				});
			}
			let CheckAllQty = 0
			for (let x = 0; x < this.selectedcheckbox.length; x++) {
				CheckAllQty += Number(this.selectedcheckbox[x].checkedqty);
			}
			this.selectqty = CheckAllQty;
		},
		getOrderSerach() {
			this.totalPage = 0;
			this.currentPage = 1;
			this.resultCount = 0;
			this.searchFlag = true;

			this.selectqty = 0;
			this.selectedrack = [];
			this.selectAll = false;
			this.selectedcheckbox = [];
			this.selectAllManually();
		},

		gotoListPage() {
			this.showList()
			this.modalMessageShowpo = false;
		},
		getbtobdata() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');

			this.isLoading = true;
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				warehouseid: this.urlwarehouseid,
				clientid: Math.abs(this.urlclientid),
				orderid: this.orderid,
				offset: (this.currentPage - 1) * 5,
				limit: this.pageLimit,
			});

			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getbtoborderdata',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.listOrdersData = result.data.data.data.orderData;
					this.totalrack = result.data.data.data.totalrack;
					this.selectAllManually();

					if (result.data.data.ErrorCode == 1) {
						this.resultCount = 0;
					} else {
						// this.filterData = result;
						this.totalRows = result.data.data.data.count;
						this.resultCount = result.data.data.data.count;
						//this.checkallflag = result.data.data.data.checkallflag;

						if (this.resultCount > 0) {
							if (this.totalRows < this.pageLimit) {
								this.totalPage = 1;
							} else {
								this.totalPage = Math.ceil(this.resultCount / this.pageLimit)
							}
						}
					}
					this.isLoading = false;
				}, error => {
					console.error(error)
				})
		},
		resetform() {

			this.$validator.reset();
			this.POmapflag = false;
			this.isError = '';
			this.poerrors = '';

		},

	}
}



// WEBPACK FOOTER //
// ./src/views/components/multipickerassign/multipickerassign.component.js